module.exports = __webpack_public_path__ + "img/OverseaMember66.de45d6a3.png";